import React from "react";

const Onion = () => {
  return <img src={require("../BurgerAssets/layerofonions.svg")} alt="" />;
};

export default Onion;
